// extracted by mini-css-extract-plugin
export default {"text-container":"TextContainer_text-container__bUROx","cursor":"TextContainer_cursor__Il1W9"};